import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { setVendorPortalToken, vendorPortalApi } from '@/api/vendorPortal.api';
import { PageHeader } from '@/components/layout/PageHeader';
import { showApiError } from '@/utils/apiError';
import { notify } from '@/core/toast/notify';

export function VendorPortalVerifyPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setError('Missing verification token');
      return;
    }
    vendorPortalApi
      .verify(token)
      .then((res) => {
        localStorage.setItem('vendor_portal_token', res.accessToken);
        setVendorPortalToken(res.accessToken);
        notify.success('Signed in to vendor portal');
        navigate('/vendor-portal/dashboard', { replace: true });
      })
      .catch((err) => {
        showApiError(err, 'Verification failed');
        setError('Link expired or invalid');
      });
  }, [navigate, params]);

  return (
    <div className="mx-auto max-w-md pt-12">
      <PageHeader title="Vendor portal" description="Verifying your login link…" />
      {error ? (
        <p className="text-sm text-red-600">
          {error}. <Link to="/vendor-portal/login">Request a new link</Link>
        </p>
      ) : (
        <p className="text-sm text-slate-500">Please wait…</p>
      )}
    </div>
  );
}
